// Matching with css variables
export enum Breakpoint {
  xsmall = '480px',
  small = '736px',
  medium = '980px',
  large = '1280px',
  xlarge = '1620px',
  xxlarge = '1690px',
}
